/* Gratis verzending op de productpagina.
   - Label boven de koopknop: vanaf de grens "Gratis verzending bij deze bestelling", net eronder "Nog €x tot gratis verzending".
   - Kaching-bundelbalken met een prijs vanaf de grens krijgen een tag "Gratis verzending" (tenzij de balk het al zegt).
   Rekent met de gekozen Kaching-balk als die er is, anders met de gekozen variant. */
(function () {
  var NEAR = 1000; /* binnen €10 van de grens: laat zien hoeveel er nog bij moet */
  function cents(t) {
    var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{3})*)(?:[.,](\d{2}))?/);
    if (!m) return null;
    return parseInt(m[1].replace(/[.,]/g, ''), 10) * 100 + (m[2] ? parseInt(m[2], 10) : 0);
  }
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  function barPrice(bar) {
    var p = bar.querySelector('.kaching-bundles__bar-price');
    return p ? cents(p.textContent) : null;
  }

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var STRIP = /\s*[+&,·-]?\s*(en\s+)?gratis verzending\s*/i;
  function tagBars(free) {
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var c = barPrice(bar), tag = bar.querySelector('.lx-ship'), sub = bar.querySelector('.kaching-bundles__bar-subtitle');
      var want = c !== null && c >= free;
      if (want && sub && STRIP.test(sub.textContent)) {
        sub.childNodes.forEach(function (n) { if (n.nodeType === 3 && STRIP.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(STRIP, ' ').trim(); });
      }
      if (want && !tag) {
        /* altijd op dezelfde plek: eigen regel direct onder de titelregel */
        var t = bar.querySelector('.kaching-bundles__bar-title');
        if (!t) return;
        var host = t, ps = t.parentElement && getComputedStyle(t.parentElement);
        if (ps && ps.display.indexOf('flex') > -1 && ps.flexDirection.indexOf('row') === 0) host = t.parentElement;
        tag = document.createElement('span'); tag.className = 'lx-ship';
        tag.innerHTML = TRUCK + 'Gratis verzending';
        host.after(tag);
      } else if (!want && tag) tag.remove();
    });
  }

  function current(el) {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (sel) { var c = barPrice(sel); if (c !== null) return c; }
    var form = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    var prices = {};
    try { prices = JSON.parse(el.getAttribute('data-prices') || '{}'); } catch (e) {}
    var qi = document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    var qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    if (form && prices[form.value] !== undefined) return prices[form.value] * qty;
    return (parseInt(el.getAttribute('data-price'), 10) || 0) * qty;
  }

  var last = '';
  function run() {
    var el = document.querySelector('[data-lx-fs]');
    if (!el) return;
    var free = parseInt(el.getAttribute('data-free'), 10) || 5500;
    tagBars(free);
    var c = current(el), t = el.querySelector('.lx-fs__t'), html, near = false;
    /* met een Kaching-bundelkiezer staat de pil al in de balken: los label dan niet tonen */
    if (document.querySelector('.kaching-bundles__bar')) html = '';
    else if (c >= free) html = 'Gratis verzending';
    else if (c > 0 && free - c <= NEAR) { html = 'Nog <b>' + eur(free - c) + '</b> tot gratis verzending'; near = true; }
    else html = '';
    var key = html + near;
    if (key === last) return;
    last = key;
    t.innerHTML = html;
    el.hidden = !html;
    el.querySelector('.lx-ship').classList.toggle('lx-ship--near', near);
  }

  var q = false;
  function schedule() { if (!q) { q = true; setTimeout(function () { q = false; run(); }, 120); } }
  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', schedule, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
